<template>
  <div>
    <div class="row">
      <h3 class="card-title" style="text-decoration:underline;">
        Στοιχεία υπαλλήλου
      </h3>
      <div class="col-md-3">
        <div class="mb-3">
          <label class="mt-3">Κατηγορία Εκπαίδευσης</label>
          <multiselect
            placeholder="Επιλογή Εκπαίδευσης"
            :options="trainingOptions"
            v-model="selectedValue"
            selectLabel="Eπιλογή Εκπαιδευσης"
            selectedLabel="Επιλέχθηκε"
            deselectLabel="Αποεπιλογή"
            :max-height="150"
          ></multiselect>
        </div>
      </div>

      <div class="col-md-4">
        <div class="mt-3">
          <label>Κλάδος</label>
          <input
            type="text"
            class="form-control"
            placeholder="π.χ. ΠΕ ΔΙΟΙΚΗΤΙΚΟΥ-ΟΙΚΟΝΟΜΙΚΟΥ"
          />
        </div>
      </div>
      <div class="col-md-4">
        <div class="mt-3">
          <label>Ειδικότητα</label>
          <input
            type="text"
            class="form-control"
            placeholder="π.χ. ΠΕ ΔΙΟΙΚΗΤΙΚΟΥ-ΟΙΚΟΝΟΜΙΚΟΥ"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-2">
        <div class="mb-3">
          <label class="mt-3">Βαθμός</label>
          <multiselect
            placeholder="Επιλογή βαθμού"
            :options="grades"
            v-model="gradeSelected"
            selectLabel="Eπιλογή βαθμού"
            selectedLabel="Επιλέχθηκε"
            deselectLabel="Αποεπιλογή"
            :max-height="150"
          ></multiselect>
        </div>
      </div>

      <div class="col-md-2">
        <label class="mt-3">Ημερομηνία Ένταξης σε Βαθμό</label>
        <b-form-input
          id="example-input"
          type="date"
          placeholder="DD-MM-YYYY"
          format="DD-MM-YYYY"
          autocomplete="off"
        ></b-form-input>
      </div>
      <div class="col-md-2">
        <label class="mt-5">Πλεονάζων στο Βαθμό:</label>
      </div>
      <div class="col-md-1">
        <label class="mt-3">Έτη</label>
        <b-form-input
          id="example-input"
          type="text"
          autocomplete="off"
        ></b-form-input>
      </div>
      <div class="col-md-1">
        <label class="mt-3">Μήνες</label>
        <b-form-input
          id="example-input"
          type="text"
          autocomplete="off"
        ></b-form-input>
      </div>
      <div class="col-md-1">
        <label class="mt-3">Ημέρες</label>
        <b-form-input
          id="example-input"
          type="text"
          autocomplete="off"
        ></b-form-input>
      </div>
    </div>

    <div class="row">
      <div class="col-md-2">
        <div class="mb-3">
          <label class="mt-3">Μισθολογικό Κλιμάκιο</label>
          <multiselect
            placeholder="Επιλογή"
            :options="mkRangeOptions"
            v-model="mkSelected"
            selectLabel="Eπιλογή"
            selectedLabel="Επιλέχθηκε"
            deselectLabel="Αποεπιλογή"
            :max-height="150"
          ></multiselect>
        </div>
      </div>
      <div class="col-md-2">
        <label class="mt-3">Ημερομηνία Ένταξης σε Κλιμάκιο</label>
        <b-form-input
          id="example-input"
          type="date"
          placeholder="DD-MM-YYYY"
          format="DD-MM-YYYY"
          autocomplete="off"
        ></b-form-input>
      </div>
      <div class="col-md-2">
        <label class="mt-5">Πλεονάζων στο Κλιμάκιο:</label>
      </div>
      <div class="col-md-1">
        <label class="mt-3">Έτη</label>
        <b-form-input
          id="example-input"
          type="text"
          autocomplete="off"
        ></b-form-input>
      </div>
      <div class="col-md-1">
        <label class="mt-3">Μήνες</label>
        <b-form-input
          id="example-input"
          type="text"
          autocomplete="off"
        ></b-form-input>
      </div>
      <div class="col-md-1">
        <label class="mt-3">Ημέρες</label>
        <b-form-input
          id="example-input"
          type="text"
          autocomplete="off"
        ></b-form-input>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="mt-3">
          <label>Φ.Ε.Κ. Διορισμού</label>
          <input type="text" class="form-control" />
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <div class="mt-3">
          <label>Οικογενειακή κατάσταση</label>
          <multiselect
            placeholder="Επιλογή"
            :options="familyStatusOptions"
            v-model="familyStatusSelected"
            selectLabel="Eπιλογή"
            selectedLabel="Επιλέχθηκε"
            deselectLabel="Αποεπιλογή"
            :max-height="100"
          ></multiselect>
        </div>
      </div>
      <div class="col-md-2">
        <div class="mt-3">
          <label>Αριθμός τέκνων</label>
          <input type="number" class="form-control" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
export default {
  name: "Ergasiaka",
  components: {
    Multiselect,
  },

  data() {
    return {
      familyStatusSelected: "",

      familyStatusOptions: [
        "Ανύπαντρος/η",
        "Έγγαμος/η",
        "Διαζευγμένος/η",
        "Χήρος/α",
      ],
      trainingOptions: ["ΠΕ", "ΤΕ", "ΔΕ", "ΥΕ"],
      selectedValue: "",
      grades: ["Α", "Β", "Γ", "Δ", "Ε "],
      gradeSelected: "",
      mkRangeOptions: [
        ...Array(19)
          .fill(1)
          .map((x, y) => x + y),
      ],
      mkSelected: "",
    };
  },
};
</script>
